import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: ${props => props.theme.colors.background.secondary};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius1};
`

export const TotalsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp32};

  p {
    min-width: ${props => props.theme.size.L};
    text-align: right;
  }
`
